'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTrailingSlash = exports.appendParam = exports.appendPath = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _curry = require('lodash/fp/curry');

var _curry2 = _interopRequireDefault(_curry);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _replace = require('lodash/fp/replace');

var _replace2 = _interopRequireDefault(_replace);

var _Maybe = require('../fp/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appendPath = exports.appendPath = (0, _curry2.default)(function (domain, path) {
  if (/\?/.test(domain)) {
    throw new TypeError('URL already followed with param, cannot append path.');
  }
  return [(0, _Maybe.maybe)('', (0, _replace2.default)(/\/$/, ''), _Maybe2.default.of(domain)), (0, _Maybe.maybe)('', (0, _replace2.default)(/^\//, ''), _Maybe2.default.of(path))].join('/');
});

var appendParam = exports.appendParam = (0, _curry2.default)(function (url, paramName, paramValue) {
  return (0, _Maybe.maybe)(url, function (v) {
    return '' + url + (/\?/.test(url) ? '&' : '?') + paramName + '=' + v.toString();
  }, _Maybe2.default.of(paramValue));
});

var removeTrailingSlash = exports.removeTrailingSlash = function removeTrailingSlash(url) {
  return url.replace(/(.+)\/$/, '$1');
};

var urlMethods = {
  appendPath: appendPath,
  appendParam: appendParam,
  removeTrailingSlash: removeTrailingSlash
};

var url = function url(target) {
  // Every operation will return a new wrapped url.
  return (0, _assign2.default)({}, (0, _mapValues2.default)(urlMethods, function (method) {
    return function () {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return url(method.apply(undefined, [target].concat(params)));
    };
  }), {
    value: function value() {
      return target;
    }
  });
};

exports.default = (0, _assign2.default)(url, urlMethods);